import searchIcon from './assets/Icons/Search.svg';
import securityIcon from './assets/Icons/Security.svg';
import { LinkButton } from '@cian/ui-kit';
import { IApplicationContext } from '../../../common/types/applicationContext';
import { clickSellerGarantLink } from '../tracking';

export const getHowItGarantWork = (context: IApplicationContext['custom']) => [
  {
    icon: searchIcon,
    title: 'Проследим за безопасностью сделки',
    descr: 'Юристы составят отчёт, подсветят риски и дадут рекомендации',
    button: (
      <LinkButton
        size="M"
        theme="fill_secondary"
        href="https://static.cdn-cian.ru/frontend/collections-assets/cpd/landing/report.pdf"
        target="_blank"
        onClick={() => clickSellerGarantLink(context, 'SafeDealReportExample')}
      >
        Посмотреть пример отчёта
      </LinkButton>
    ),
  },
  {
    icon: securityIcon,
    title: 'Организуем защиту от финансовых потерь',
    descr:
      'Сертификат действует 3 года. Если сделку попытаются оспорить — отстоим ваши права в суде или компенсируем 100% стоимости жилья при утрате прав собственности',
    button: (
      <LinkButton
        size="M"
        theme="fill_secondary"
        href="https://static.cdn-cian.ru/frontend/collections-assets/cpd/landing/sert.pdf"
        target="_blank"
        onClick={() => clickSellerGarantLink(context, 'SafeDealCertificateExample2')}
      >
        Посмотреть пример сертификата
      </LinkButton>
    ),
  },
];
